<template>
  <div>
    <header-mx></header-mx>
    <section class="main">
      <div class="figuras">
        <div class="container-fluid">
          <!-- <div
            class="row"
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-duration="500"
          >
            <div class="col-md-8 offset-md-2 text-center">
              <img class="img-fluid" src="../assets/imgs/coca/video.png" alt="video">
              <p class="fG pt-5">
                Bienvenido a la <strong>Academia Digital Walmart</strong> hoy conoceremos la ejecución correcta en piso de venta.
              </p>
            </div>
          </div> -->

          <div
            class="row pt-5"
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-duration="500"
          >
            <div class="col-12 text-center fG pb-3">
              <div class="row">
                <div class="col-12">
                  <img
                    src="../assets/imgs/coca/usuario.jpg"
                    alt="Usuario"
                    class="img-fluid"
                  />
                </div>
                <div class="col-12 py-4">
                  <span class="">Para comenzar,&nbsp;</span>
                  <strong>inicia sesión</strong>.
                </div>
              </div>
            </div>
            <!-- <div class="col-12 text-center white fG pb-3">
                  <a href class="btn btnfb">
                    <i class="fab fa-facebook-square"></i> Inicia con
                    <span class="bold">Facebook</span>
                  </a>
                </div>-->
            <!-- <div class="col-12 text-center white fG pb-3">ó</div> -->
          </div>
          <div
            class="row pb-3"
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-duration="500"
          >
            <div class="formulario col-12 col-lg-6 offset-lg-3 pt-2 pb-4 fG">
              <form method="post" @submit="submitFormulario($event)">
                <label>
                  <input
                    type="text"
                    v-model="no_determinante"
                    maxlength="100"
                    placeholder="Número Determinante (Tienda)"
                    required
                  />
                </label>

                <label class="m-0">
                  <input
                    type="password"
                    v-model="password"
                    maxlength="100"
                    placeholder="Contraseña"
                    required
                  />
                </label>

                <div
                  class="d-flex justify-content-center align-items-center py-3"
                >
                  <!-- <div class="col-6">
                    <div class="d-flex justify-content-center">
                      <div class="row pb-2">
                        <div class="col-12">
                          <router-link to="/recuperacion" class="gris"
                            >¿Olvidaste tu contraseña?</router-link
                          >
                        </div>
                      </div>
                    </div>
                  </div> -->
                  <div class="col-12">
                    <div class="text-center pt-2">
                      <button type="submit" class="submit btn btnsup w-100">
                        Entrar
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <!-- <div class="col-12">
              <div class="row pb-5">
                <div class="col-12 text-center white fXG py-5">
                  ¿Aún no estás registrado?
                </div>
                <div class="col-12 text-center">
                  <button
                    type="button"
                    class="btn btnsup"
                    @click="abreRegistro()"
                  >
                    Crea una cuenta
                  </button>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>

      <footer-mx></footer-mx>
    </section>
  </div>
</template>

<script>
import AOS from "aos";
import swal from "sweetalert2";
import Header from "../Components/Header.vue";
import Footer from "../Components/Footer.vue";

export default {
  name: "AcademiaDigital",
  props: {
    msg: String,
  },
  data() {
    return {
      no_determinante: "",
      password: "",
      redirect_url: "",
    };
  },
  mounted: function () {
    this.$cookie.delete("usersupmdlp");
    this.$cookie.delete("useracademiadigital");

    //    //this.$store.state.user = JSON.parse(this.$cookie.get("useracademiadigital"));
    try {
      this.$store.state.user = JSON.parse(
        localStorage.getItem("useracademiadigital")
      );
    } catch (e) {
      //algo
    }

    AOS.init();
  },
  components: {
    "footer-mx": Footer,
  },
  methods: {
    clickComprar() {
      this.$gtag.event("Click comprar", {
        event_category: "MDLP",
      });
    },
    clickRecetario() {
      this.$gtag.event("Descarga recetario", {
        event_category: "MDLP",
      });
    },
    abreRegistro() {
      this.$gtag.event("Click crear cuenta", {
        event_category: "MDLP",
      });
      this.$router.push("/registro");
    },
    submitFormulario(e) {
      console.log("submit");
      var vm = this;
      e.preventDefault();

      const https = require("https");

      vm.$store.state.loading = true;

      if(!this.revisaLogin()){

        vm.$store.state.loading = false;

        swal.fire(
          "Oops",
          "El No. determinante o Contraseña no son válidos. ",
          "warning"
        );


        return;
      }

      // // // var qData = {
      // // //   no_determinante: this.no_determinante,
      // // //   password: this.password,
      // // // };

      // // // let formData = new FormData();
      // // // formData.append("form_data", JSON.stringify(qData));

      localStorage.setItem('useracademiadigital', this.no_determinante)
      console.log("enviando");
      //console.log(JSON.stringify(qData));

      this.$router.push("/dashboard");

      vm.$store.state.loading = false;

      // // // this.$http
      // // //   .post(this.$store.state.baseurl + "login.php", formData, {
      // // //     emulateJSON: true,
      // // //     httpsAgent: new https.Agent({ rejectUnauthorized: false }),
      // // //     headers: {
      // // //       "Content-Type": "multipart/form-data",
      // // //       //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
      // // //     },
      // // //   })
      // // //   .then(
      // // //     (response) => {
      // // //       // get body data
      // // //       console.log("envio");
      // // //       console.log(response);
      // // //       vm.$store.state.loading = false;
      // // //       //console.log(response.data);
      // // //       var res = response.data;

      // // //       if (res.status == "ok") {
      // // //         //this.$cookie.set("useracademiadigital", JSON.stringify(res.user), 1);
      // // //         //this.$store.state.user = this.$cookie.get("useracademiadigital");

      // // //         localStorage.setItem("useracademiadigital", JSON.stringify(res.user));
      // // //         this.$store.state.user = JSON.stringify(res.user);

      // // //         this.$gtag.event("Login en aplicación", {
      // // //           event_category: "MDLP",
      // // //         });

      // // //         if (
      // // //           this.redirect_url != "" &&
      // // //           this.redirect_url != "null" &&
      // // //           this.redirect_url != null
      // // //         ) {
      // // //           this.$router.push(this.redirect_url);
      // // //         } else {
      // // //           this.$router.push("/dashboard");
      // // //         }
      // // //       } else if (res.status == "notok") {
      // // //         swal.fire("Oops", res.msg, "warning");

      // // //         if (res.verificacion == 0) {
      // // //           this.$router.push("/verificacion/" + this.email);
      // // //         }
      // // //       }
      // // //     },
      // // //     (error) => {
      // // //       // error callback
      // // //       console.log("error callback");
      // // //       console.log(error);
      // // //       vm.$store.state.loading = false;
      // // //       //console.log(userData);
      // // //       swal.fire(
      // // //         "Oops",
      // // //         "Ha ocurrido un error en el envío, por favor intenta de nuevo.",
      // // //         "warning"
      // // //       );
      // // //     }
      // // //   );
    },
    revisaLogin() {
      console.log('revisando login');
      console.log(this.no_determinante);
      

      var vm = this;
      var flag = false;

      console.log(vm.$store.state.ids)

      var contains = false;
      vm.$store.state.ids.forEach(element => {
        //console.log(element);
        if(parseInt(element) === parseInt(this.no_determinante)){
          contains = true;
        }
      });

      if (contains) {
        console.log('sí incluye')
        if (this.password === vm.$store.state.pass) {
          flag = true;

          console.log('enviando evento: ' + this.no_determinante );
          console.log(this.$gtag);
          
          this.$gtag.event("Login", {
            event_category: this.no_determinante,
          });


        }
      }

      return flag;
    },
  },
};
</script>

